import React from "react";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";

import BaseLink from "@components/toolkit/BaseLink/BaseLink";

import "./RecaptchaDisclaimer.scss";

interface RecaptchaDisclaimerProps {
  className?: string;
}

const RecaptchaDisclaimer = ({ className }: RecaptchaDisclaimerProps) => {
  const { t } = useTranslation("recaptcha");

  const classes = classNames("recaptcha-disclaimer", className);

  return (
    <div className={classes}>
      <Trans i18nKey="disclaimer" t={t}>
        <BaseLink href="https://policies.google.com/privacy" target="_blank">
          Privacy Policy
        </BaseLink>

        <BaseLink href="https://policies.google.com/terms" target="_blank">
          Terms of Service
        </BaseLink>
      </Trans>
    </div>
  );
};

export default RecaptchaDisclaimer;
